import { render, staticRenderFns } from "./MemberDocumentsDialog.vue?vue&type=template&id=4e9b2b79"
import script from "./MemberDocumentsDialog.vue?vue&type=script&lang=ts"
export * from "./MemberDocumentsDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports